import { render } from "./GalleryParagraphText.vue?vue&type=template&id=1ddec18f&scoped=true"
import script from "./GalleryParagraphText.vue?vue&type=script&lang=js"
export * from "./GalleryParagraphText.vue?vue&type=script&lang=js"

import "./GalleryParagraphText.vue?vue&type=style&index=0&id=1ddec18f&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ddec18f"]])

export default __exports__